module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Union-af1efd3b5c9adb220b358a6619d3a74e.svg";